<template>
  <div class="header-box">
    <div class="header">
      <!-- logo -->
      <img class="logo" @click="goToStartPage" src="@/assets/images/iedu/logo.jpeg" />
      <!-- <img class="logo" src="../assets/images/img_32387_0_493.png" @click="goToStartPage" /> -->
      <div class="nav-box" v-if="!searchShow">
        <ul>
          <div href @click="changTab(0)" :class="activeName == 'home'?'active':''">
            <li>
              <span class="line"></span>
              首页
            </li>
          </div>
          <div href @click="changTab(1)" :class="activeName == 'book'?'active':''">
            <li>
              <span class="line"></span>
              精选好书
            </li>
          </div>
          <div href @click="changTab(2)" :class="activeName == 'course'?'active':''">
            <li>
              <span class="line"></span>
              精选好课
            </li>
          </div>
        </ul>
      </div>
      <!-- 搜索部分 -->
      <!-- <div class="search-box">
        <img @click="showSearchInput" src="../assets/images/search.png" alt class="icon" />
        <transition name="draw">
          <div class="really-box" v-show="searchShow">
            <input
              ref="inputs"
              @keyup.enter="search"
              type="text"
              class="search-input"
              v-model="value"
              placeholder="搜索感兴趣的课程"
            />
            <img
              @click="clearSearch"
              src="../assets/images/closeSearch.png"
              alt
              class="closeSearch"
            />
          </div>
        </transition>
      </div>-->
      <!-- 用户部分 -->
      <div class="user-box">
        <!--未登录状态开始-->
        <div class="login-box" v-if="!loginInfoGetters.status">
          <span class="txt" @click="registered">登录</span>
          <!-- <span class="txt">｜</span>
          <span class="txt" @click="logIn">登录</span>-->
        </div>
        <div class="login-box" v-else>
          <span class="txt" @click="loginOut">退出</span>
          <span>｜</span>
          <span class="txt" @click="toMy" v-if="loginInfoGetters.name">{{loginInfoGetters.name}}</span>
          <!-- <span v-else>{{phone}}</span> -->
        </div>

        <!--未登录状态结束-->
        <!--登录状态开始-->
        <!-- <span class="text_2" :lines="1">阿佳</span> -->
        <!--登录状态结束-->
        <!-- <img v-if="userUrl" @click="myCourse" class="user-icon" :src="userUrl" />
        <img v-else @click="myCourse" class="user-icon" src="../assets/du.png" />-->
      </div>
    </div>
  </div>
</template>

<script>
import imgPath from "@/common/img-path";
import { mapMutations, mapGetters } from "vuex";
import bus from "@/common/bus";
import { getUserInfo, setLoginOut, searchSolr, Logout } from "@/servers/api";
export default {
  name: "BodyHeader",
  data() {
    return {
      value: "",
      searchShow: false,
      activeName: "",
      phone: "", // 用户手机号
      userUrl: "", // 用户头像
      nickName: "", // 用户昵称
      loginRandom: "",
      userRandom: "",
      isLogin: false,
      isSearch: false,
      filter: {
        name: "",
        // 是否为专题训练营 ''为精品课 1是专题训练营
        isTrainingCamp: "",
        pageNum: 1,
        pageSize: 0
      }
    };
  },

  mounted() {},
  methods: {
    ...mapMutations([
      "setDialogMutations",
      "dialogTypeMutations",
      "changeSearchCondition",
      "changeList",
      "changePageInfo",
      "reSetSearchCondition",
      "changeResetFlag",
      "changeSearchVal",
      "changeLoginInfo"
    ]),
    clearSearch() {
      this.value = "";
      this.searchShow = false;
    },
    showSearchInput() {
      if (this.value) {
        this.search();
      } else {
        this.searchShow = true;
      }
    },
    async search() {
      this.reSetSearchCondition();
      this.changeSearchCondition({ key: "name", value: this.value });
      this.changeSearchVal(this.value);
      if (this.activeName == "home") {
        this.activeName = "book";
        this.$router.push({
          path: "/book",
          query: {}
        });
      } else {
        const params = {
          ...this.searchConditionGetters
        };
        const res = await searchSolr(params);
        if (res.code == 0) {
          this.changeList(res.data);
          const data = {
            total: res.total
          };
          this.changePageInfo(data);
          this.changeResetFlag(true);
        }
      }
    },
    myCourse() {
      if (!localStorage.getItem("token")) {
        this.logIn();
        return false;
      }
      this.activeName = "";
      this.$router.push("/mine/course");
    },
    scrollOrient() {
      if (this.activeName === "home") {
        document.getElementById("orient-box").scrollIntoView();
        this.activeName = "orientDetail";
      } else {
        this.$router.push("/");
      }
    },
    toMy() {
      this.$router.push("/my");
    },
    changTab(num) {
      switch (num) {
        case 0:
          this.activeName = "home";
          this.$router.push("/");
          break;
        case 1:
          // 精品课程
          this.activeName = "book";
          this.$router.push("/book");
          break;
        case 2:
          // 专题训练营
          this.activeName = "course";
          this.$router.push("/course");
          break;
        case 3:
          // 师资团队
          this.activeName = "teacherList";
          this.$router.push("/teacher/list");
          break;
        // case 4:
        //   // 职业认证
        //   this.activeName = "certification";
        //   this.$router.push("/course");
        //   break;
      }
    },
    gocourse() {
      console.log("点击职业认证", this.$route.query.pid);
      // this.activeName = 'course'
      this.activeName = "book";
      if (this.$route.query.pid != "984") {
        this.$router
          .replace({
            // path:"/course",
            path: "/book",
            query: {
              pid: "984"
            }
          })
          .catch(e => {
            console.log(e);
          });
      }
    },
    handleClickToLogin() {
      //this.
    },
    //
    registered() {
      this.dialogTypeMutations("join");
      this.setDialogMutations(true);
    },
    logIn() {
      this.dialogTypeMutations("login");
      this.setDialogMutations(true);
    },
    goToStartPage() {
      this.activeName = "home";
      this.$router.push({
        path: "/",
        query: {}
      });
    },
    // 获取用户信息
    async getUserInfo() {
      const res = await getUserInfo();
      console.log("res", res);
      if (res.code == 0) {
        this.phone = res.data.phone;
        this.nickName = res.data.nickName;
        this.userUrl = res.data.headerImageUrl;
        localStorage.setItem("userUrl", res.data.headerImageUrl);
        localStorage.setItem("userPhone", res.data.phone);
        localStorage.setItem("userName", res.data.nickName);
      }
    },
    // 退出
    loginOut() {
      Logout().then(res => {
        if (res.errcode == 0) {
          localStorage.removeItem("Auth");
          this.changeLoginInfo({
            status: false,
            name: ""
          });
          this.$Toast({
            content: "退出成功",
            type: "success"
          });
          this.$router.push({ path: "/" });
        }
      });
    },
    // 控制搜索栏
    showSearch() {
      let tempHash = window.location.hash;
      if (tempHash == "#/") {
        this.isSearch = true;
      }
      if (tempHash.indexOf("book") != -1) {
        this.isSearch = true;
      }
      if (tempHash.indexOf("course") != -1) {
        this.isSearch = true;
      }
    }
  },
  created() {
    this.activeName = this.$route.name;
    var userInfo;
    if (localStorage.getItem("Auth")) {
      userInfo = JSON.parse(localStorage.getItem("Auth"));
      this.changeLoginInfo({
        status: true,
        name: userInfo.username
      });
    } else {
      this.changeLoginInfo({
        status: false,
        name: ""
      });
    }
    // this.getUserInfo()
  },
  computed: {
    searchType() {
      return this.activeName == "course" ? 1 : 0;
    },
    ...mapGetters([
      "searchConditionGetters",
      "searchValGetters",
      "loginInfoGetters"
    ])
  }
};
</script>

<style scoped lang="less">
.header-box {
  background-color: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  margin-bottom: 4px;
  .header {
    width: 1200px;
    margin: 0 auto;
    height: 74px;
    //logo
    .logo {
      float: left;
      // width: 270px;
      height: 74px;
      cursor: pointer;
      // margin-top: 20px;
    }
    // nav
    .nav-box {
      float: left;
      margin-left: 30px;
    }
    // search
    // user box
    .user-box {
      height: 100%;
      float: right;
      .login-box {
        height: 74px;
        line-height: 74px;
      }
    }
  }
}

.nav-box div {
  cursor: pointer;
  display: inline-block;
  text-align: center;
  margin-left: 30px;
}
.nav-box ul div li {
  position: relative;
  height: 74px;
  line-height: 74px;
  text-align: center;
  font-size: 18px;
  color: #23374d;
  letter-spacing: 1px;
}
.nav-box ul .active li {
  font-weight: 500;
}
.nav-box ul li .line {
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 0;
  border-top: 6px solid #FFDB6A;
  /* -webkit-transition: all .3s;
        transition: all .3s; */
}
.nav-box ul .active li .line {
  left: 0;
  width: 100%;
}
.nav-box ul div:hover li .line {
  left: 0;
  width: 100%;
}

.word {
  opacity: 1;
  margin-top: 11px;
  margin-right: 30px;
  line-height: 25px;
  letter-spacing: 1.5px;
  white-space: nowrap;
  color: #23374d;
  font-size: 18px;
  font-weight: 400;
}

.text {
  opacity: 1;
  margin-top: 11px;
  margin-right: 30px;
  line-height: 25px;
  letter-spacing: 1.5px;
  white-space: nowrap;
  color: #23374d;
  font-size: 18px;
  font-weight: 400;
}

.info {
  opacity: 1;
  margin-top: 11px;
  margin-right: 30px;
  line-height: 25px;
  letter-spacing: 1.5px;
  white-space: nowrap;
  color: #23374d;
  font-size: 18px;
  font-weight: 400;
}

.word_2 {
  opacity: 1;
  margin-top: 11px;
  margin-right: 108px;
  line-height: 25px;
  letter-spacing: 1.5px;
  white-space: nowrap;
  color: #23374d;
  font-size: 18px;
  font-weight: 400;
}

.search-box {
  height: 100%;
  // display: flex;
  align-items: center;
  float: left;
  position: relative;
  background-color: #ffffff;
  // margin-right: -30px;
  margin-top: 20px;
  // margin-bottom: 10px;
  cursor: pointer;
}
.search-input {
  float: left;
  width: 192px;
  height: 32px;
  border-width: 1px;
  border-style: solid;
  box-sizing: border-box;
  border-color: rgba(15, 137, 255, 1);
  padding-left: 10px;
}
.info_2 {
  opacity: 1;
  margin-top: 6px;
  margin-right: 39px;
  margin-left: 30px;
  max-width: 155px;
  height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 20px;
  letter-spacing: 1.17px;
  white-space: nowrap;
  color: #b7b7b7;
  font-size: 14px;
  font-weight: 400;
}

.search-btn {
  float: left;
  box-sizing: border-box;
  cursor: pointer;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(15, 137, 255, 1);
  background-color: #0f89ff;
  width: 60px;
  height: 32px;
}

input::-webkit-input-placeholder {
  padding-left: 20px;
  font-size: 14px;
  color: rgba(183, 183, 183, 1);
  letter-spacing: 1px;
}
.icon {
  margin-top: 8px;
  margin-left: 20px;
  width: 16px;
  height: 16px;
}

.txt {
  opacity: 1;
  margin-top: 13px;
  line-height: 20px;
  letter-spacing: 1.17px;
  /* white-space: nowrap; */
  color: #23374d;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
}
/* .login-box {
    } */
.user-icon {
  float: left;
  cursor: pointer;
  border-radius: 38px;
  background-color: #f4f5f6;
  margin-left: 10px;
  width: 38px;
  height: 38px;
  margin-top: 2px;
}

.dot {
  position: absolute;
  top: 22px;
  right: 11px;
  width: 4px;
  height: 6px;
}
</style>
<style lang="less" scoped>
.really-box {
  height: 100%;
  width: 300px;
  display: flex;
  align-items: center;
  .search-input {
    border: 0 none;
    border-bottom: 1px solid gray;
    margin: 0 20px;
  }
  .closeSearch {
    width: 16px;
    height: 16px;
  }
}
.draw-enter-active,
.draw-leave-active {
  transition: all 0.1s ease;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
  width: 0;
}
</style>
